export default __webpack_public_path__ + "static/media/38.a1814d65.jpg";